import React, { useState, useContext } from 'react';
import { useNavigate } from "react-router-dom";
import 'bulma/css/bulma.min.css';

import { BeamlineContext } from '../../beamlineProvider.tsx';
import { ScanTypeSlug, ScanType } from '../../scanTypes.ts';


interface DeleteScanTypeProps {
  scantypeslug: ScanTypeSlug;
}


const DeleteScanType: React.FC<DeleteScanTypeProps> = (props) => {

  const beamlineContext = useContext(BeamlineContext);
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [inProgress, setInProgress] = useState<boolean>(false);
  const [submitErrorMessage, setSubmitErrorMessage] = useState<string | null>(null);

  function getScanType(): ScanType | undefined {
    if (!props.scantypeslug) { return undefined; }
    return beamlineContext.scanTypes.typesBySlug.get(props.scantypeslug);
  }

  function clickedOpen() {
    const thisScanType = getScanType();
    if (!inProgress && !isOpen && thisScanType) {
      setIsOpen(true);
    }
  }

  async function pressedSubmit() {
    const thisScanType = getScanType();
    if (!thisScanType) { return; }

    setSubmitErrorMessage(null);
    setInProgress(true);
    const result = await beamlineContext.scanTypes.deleteScanTypeFromServerAndRemove(thisScanType.slug);
    beamlineContext.changed();
    setInProgress(false);
    if (!result.success) {
      setSubmitErrorMessage(result.message || "");
    } else {
      setIsOpen(false);
      navigate('../', { relative: "route" });
    }
  };

  function clickedClose() {
    if (!inProgress) { setSubmitErrorMessage(null); setIsOpen(false); }
  }

  return (
    <a className="dropdown-item" onClick={ clickedOpen }>Delete Scan Type

      <div id="modal-add-sample" className={ isOpen ? "modal is-active" : "modal" }>
        <div className="modal-background"></div>

        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title">Delete Scan Type</p>
            <button className="delete" aria-label="close" onClick={ clickedClose }></button>

          </header>
          <section className="modal-card-body">

            <div className="block">
              <p>
                Are you sure you want to delete Scan Type <b>{ getScanType()?.name }</b>?
              </p>
              <p>
                <b>This operation cannot be undone!</b>
              </p>
            </div>

            <div className="buttons">
              <input
                type="button"
                className="button is-danger"
                onClick={ pressedSubmit }
                disabled={ inProgress }
                value="Delete"
              />
              <button className="button" onClick={ clickedClose }>Cancel</button>
            </div>

            { submitErrorMessage && (
              <article className="message is-danger">
                <div className="message-body">
                  { submitErrorMessage }
                </div>
              </article>
            )}

          </section>

        </div>
      </div>

    </a>
  )
}
export default DeleteScanType
